import React from 'react';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
} from '@chakra-ui/react';
import { FaShieldAlt } from 'react-icons/fa';
import SEO from '../components/SEO';
import ScrollIndicator from '../components/ScrollIndicator';

const Privacy = () => {
  return (
    <>
      <Box minH="100vh" pt={{ base: 20, md: 20 }} pb={{ base: 12, md: 20 }} id="privacy-container">
        <SEO
          title="Privacy Policy - Namaskar India"
          description="Privacy policy for Namaskar India podcast."
          noindex={true}
        />

        <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
          <VStack spacing={{ base: 8, sm: 10, md: 12 }} align="stretch">
            {/* Header */}
            <VStack spacing={{ base: 3, sm: 4 }} maxW="3xl" mx="auto" textAlign="center">
              <Heading
                as="h1"
                fontSize={{ base: "3xl", sm: "4xl", md: "6xl", lg: "7xl" }}
                lineHeight="1.2"
                variant="gradient"
              >
                Privacy Policy
              </Heading>
            </VStack>

            {/* Content */}
            <Box
              maxW="2xl"
              mx="auto"
              w="full"
              background="rgba(255,150,50,0.04)"
              backdropFilter="blur(12px)"
              borderRadius="2xl"
              border="1px solid rgba(255,150,50,0.08)"
              p={{ base: 6, md: 10 }}
              position="relative"
              overflow="hidden"
            >
              <Box position="absolute" top={0} left={0} right={0} h="2px" bgGradient="linear(to-r, transparent, brand.500, transparent)" />
            <VStack spacing={{ base: 6, sm: 7, md: 8 }} align="stretch">
              <Text 
                color="whiteAlpha.900" 
                fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                lineHeight="tall"
              >
                At Namaskar India, we respect your privacy and are committed to protecting it. This policy outlines our practices regarding information collection and usage.
              </Text>

              <List spacing={{ base: 4, sm: 5, md: 6 }}>
                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaShieldAlt} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text 
                    color="whiteAlpha.900" 
                    fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                    lineHeight="tall"
                  >
                    We use standard podcast analytics to understand how our content is being consumed. This includes basic information like play counts and download statistics. We do not collect any personally identifiable information through our podcast feeds.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaShieldAlt} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text 
                    color="whiteAlpha.900" 
                    fontSize={{ base: "md", sm: "lg", md: "xl" }} 
                    lineHeight="tall"
                  >
                    If you choose to join our community groups or interact with us on social media, we only use this interaction for communication within those platforms. We never share your information with third parties.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaShieldAlt} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text
                    color="whiteAlpha.900"
                    fontSize={{ base: "md", sm: "lg", md: "xl" }}
                    lineHeight="tall"
                  >
                    This website does not use cookies, trackers, or any analytics tools. We do not collect, store, or process any personal data from visitors.
                  </Text>
                </ListItem>

                <ListItem display="flex" alignItems="flex-start">
                  <ListIcon as={FaShieldAlt} color="brand.500" mt={1} boxSize={{ base: 5, md: 6 }} />
                  <Text
                    color="whiteAlpha.900"
                    fontSize={{ base: "md", sm: "lg", md: "xl" }}
                    lineHeight="tall"
                  >
                    For any privacy concerns or questions, please reach out via our <Text as="span" color="brand.400">Contact</Text> page.
                  </Text>
                </ListItem>
              </List>

              <Text color="whiteAlpha.500" fontSize="sm" textAlign="center" mt={4}>
                Last updated: March 2026
              </Text>
            </VStack>
            </Box>
          </VStack>
        </Container>
        <ScrollIndicator containerId="privacy-container" />
      </Box>
    </>
  );
};

export default Privacy;
